import api from '../lib/api';

export interface FrequentContact {
  id: string;
  organization_id: string;
  name: string;
  email: string;
  type: 'supplier' | 'warehouse' | 'shipping' | 'vendor' | 'partner' | 'other';
  created_by: string;
  created_at: string;
  updated_at: string;
  organization_name?: string;
  created_by_email?: string;
  created_by_first_name?: string;
  created_by_last_name?: string;
  ticket_count?: number;
}

export interface CreateFrequentContactData {
  name: string;
  email: string;
  type?: 'supplier' | 'warehouse' | 'shipping' | 'vendor' | 'partner' | 'other';
  organizationId?: string;
}

export interface UpdateFrequentContactData {
  name: string;
  email: string;
  type?: 'supplier' | 'warehouse' | 'shipping' | 'vendor' | 'partner' | 'other';
}

export interface FrequentContactsListResponse {
  success: boolean;
  data: FrequentContact[];
}

export interface FrequentContactResponse {
  success: boolean;
  data: FrequentContact;
  message?: string;
}

class FrequentContactsService {
  async listContacts(organizationId?: string): Promise<FrequentContactsListResponse> {
    const params = organizationId ? { organizationId } : {};
    const response = await api.get<FrequentContactsListResponse>('/frequent-contacts', { params });
    return response.data;
  }

  async getTopContacts(organizationId?: string, limit?: number): Promise<FrequentContactsListResponse> {
    const params: Record<string, string | number> = {};
    if (organizationId) params.organizationId = organizationId;
    if (limit) params.limit = limit;
    const response = await api.get<FrequentContactsListResponse>('/frequent-contacts/top', { params });
    return response.data;
  }

  async getContact(id: string): Promise<FrequentContactResponse> {
    const response = await api.get<FrequentContactResponse>(`/frequent-contacts/${id}`);
    return response.data;
  }

  async createContact(data: CreateFrequentContactData): Promise<FrequentContactResponse> {
    const response = await api.post<FrequentContactResponse>('/frequent-contacts', data);
    return response.data;
  }

  async updateContact(id: string, data: UpdateFrequentContactData): Promise<FrequentContactResponse> {
    const response = await api.put<FrequentContactResponse>(`/frequent-contacts/${id}`, data);
    return response.data;
  }

  async deleteContact(id: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete<{ success: boolean; message: string }>(`/frequent-contacts/${id}`);
    return response.data;
  }
}

export default new FrequentContactsService();
